import * as React from 'react';
import styled, { css } from 'styled-components';

export const COLORS = {
  gray: '#848E9C',
  green: '#70A800',
  black: '#212833',
  lightGray: '#EAECEF',
  yellow: '#F0B90B',
  red: '#F23051',
};

export const Word = styled.div`
  font-size: ${({ fontSize }) => fontSize || '14px'};
  color: ${({ color }) => COLORS[color] || COLORS.lightGray};
`;

export const TabPanelDiv = styled.div`
  margin: 40px 0px 72px;
  
  tr {
    height: 40px;
  }
`;

export const TabPanelTitle = styled(Word).attrs(() => ({
  color: 'black',
  fontSize: '16px',
}))`
  line-height: 28px;
  margin-bottom: 24px;
`;

const widthStyle = css`
  max-width: 1260px;
  margin: 24px auto;
`;

const Bg = styled.div`
  background-color: transparent;
`;

const Wrapper = styled.div`
  ${widthStyle};
  margin: 0 auto;
  padding: 48px 0;
`;

type BlockProps = {
  children: React.Node,
  className: string,
}

export const Block = ({ children, className }: BlockProps) => (
  <Bg className={className}>
    <Wrapper>
      {children}
    </Wrapper>
  </Bg>
);

export const SpinnerStyle = css`
  position: relative;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: ${({ dark }) => dark ? 'black' : 'white'};
    opacity: ${({ isLoading }) => isLoading ? '.9' : '0'};
    pointer-events: none;
  }
`;
